import angular from "angular";
import pickFromChoicesDialogPreset from "./pick_from_choices_dialog.config";

export default angular
    .module("sbApp.dialogs.pickFromChoices", [])
    .config(pickFromChoicesDialogPreset);
